import React, { useEffect } from "react";
import InterfaceComponent from "../Masters/InterfaceComponent";
import { ActionHandlerProvider } from "../../Components/ActionHandlerContext";
import { useRef } from "react";
import { FormInstance, message } from "antd";
import { API } from "../../Axios/Axios";
import {
  CustomFunction,
  getRequestDetailsById,
  getUserDeptAndUnit,
  InitiateAcknowledgementAsync,
  InitiateComplaintAsync,
  InitiateQAClosureAsync,
  InitiateSalesClosureAsync,
  FetchRequestOrUserContext
} from "../../Helpers/APIEndpoints/Endpoints";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from "../../AuthStore/AuthStore";
import dayjs from "dayjs";
import { DocumentTypeEnum } from "../../Enum/DocumentTypeEnum";
import { ApiStatus } from "../../Enum/ApiStatusEnum";
import { RoleEnum } from "../../Enum/RoleEnum";
import { RequestStatusEnum } from "../../Enum/RequestStatusEnum";

const RequestDetailInterface = () => {
  const formRef = useRef<FormInstance>(null);
  const { commonContextParams } = useAuthStore();

  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const queryRId = searchParams.get("RId");
  const isFromEmail = !!queryRId;

  const { RId } = location?.state?.RId || {};
  const { TId } = location?.state?.TId || {};
  const { CId } = location?.state?.CId || {};
  const hasRedirected = useRef(false);

  ////Redirection Logic - Email Link Redirection
  // useEffect(() => {
  //   //if (queryRId && !RId) {
  //   if (queryRId) {
  //     navigate(location.pathname + `?RId=${queryRId}`, {
  //       replace: true,
  //       state: {
  //         actionType: "Edit",
  //         RId: Number(queryRId),
  //         Mode: "Edit",
  //       },
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (queryRId) {
      navigate(location.pathname, {
        replace: true,
        state: {
          actionType: "Edit",
          RId: Number(queryRId),
          Mode: "Edit",
        },
      });
    }
  }, []);

  let RequestStatusId = 0;

  //#region Field Configurations
  const ComplaintDetailTabFields = [
    {
      fieldName: "Initiator",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "InitiatorDepartment",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "InitiatorUnit",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ComplaintDate",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ContactChannel",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Description",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "BusinessChannel",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CustomerName",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ContactPerson",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ContactNumber",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "EmailAddress",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Country",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Product",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ProductDescription",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ComplaintDetailsDocuments",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "SupportingDocuments",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Series",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ReferenceNumber",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ComplaintTitle",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CustomerCode",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "CustomerAddress",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "City",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ProductCode",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "IssueReportedBy",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Priority",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "StatusId",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestDetailSave",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "RequestDetailSubmit",
      updates: { isFieldDisable: true },
    },

  ];

  const AcknowledgementDetailsTabFields = [
    {
      fieldName: "Investigator",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "QATeamRemark",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Impact",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "TargetClosureDate",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "AcknowledgementSubmit",
      updates: { isFieldDisable: true },
    }
  ];

  const ClosureDetailsSalesRepTabFields = [
    {
      fieldName: "CustomerRemark",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ClosureDetailsSalesRepDocuments",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "Rating",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ClosureDetailsSalesRepSubmit",
      updates: { isFieldDisable: true },
    }
  ];

  const ClosureDetailsQATeamTabFields = [
    {
      fieldName: "QATeamComplaintStatus",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "FinalClosureRemarks",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ClosureDetailsQATeamDocuments",
      updates: { isFieldDisable: true },
    },
    {
      fieldName: "ClosureDetailsQATeamSubmit",
      updates: { isFieldDisable: true },
    }
  ];

  const tabFieldConfig: Record<string, any[]> = {
    "Complaint Details": ComplaintDetailTabFields,
    "Acknowledgement Details": AcknowledgementDetailsTabFields,
    "Closure Details Sales Rep": ClosureDetailsSalesRepTabFields,
    "Closure Details QA Team": ClosureDetailsQATeamTabFields,
  };

  const shouldRedirect = sessionStorage.getItem("redirectToActionDetails");
  const shouldCorrActionRedirect = sessionStorage.getItem("redirectToCorrActionDetails");

  const handleFieldVisibility = (
    tabNames: string | string[],
    disableFlag: boolean,
  ): Array<{ fieldName: string; updates: any }> => {
    const tabsArray = Array.isArray(tabNames) ? tabNames : [tabNames];

    return tabsArray.flatMap((tabName) => {
      const fields = tabFieldConfig[tabName];
      if (!fields) return [];

      return fields.map((field) => ({
        ...field,
        updates: {
          ...field.updates,
          isFieldDisable: disableFlag,
        },
      }));
    });
  };

  //#endregion

  const disableTabs = (tabNames: string[]) => {
    formRef.current?.disableTabs(tabNames);
  };

  const enableTabs = (tabNames: string[]) => {
    formRef.current?.enableTabs(tabNames);
  };

  const presetValues = (values: Record<string, any>) => {
    Object.entries(values).forEach(([key, val]) => {
      formRef.current?.setValue(key, val);
    });
  };

  const handleCancel1 = () => {
    // // Navigate back to the previous page
    //navigate(-1);

    if (Number(commonContextParams?.roleId) == Number(RoleEnum.TaskActionOwner)) {
      navigate("/ActionDashboard");
    }
    else if (Number(commonContextParams?.roleId) == Number(RoleEnum.CorrectiveActionOwner)) {
      navigate("/CorrectiveActionDashboard");
    }
    else {
      navigate("/ComplaintsDashboard");
    }
  };

  const interfaceActionHandler = {
    customJsonMethod: async (apiValues: any, fieldName: any) => {
      console.log("customJsonMethod called");
      let value = {
        testMarks: 32358,
      };

      return value;
    },
    PrevTab: () => {
      formRef.current?.setPrevTabAsActive();
    },
    NextTab: () => {
      formRef.current?.setNextTabAsActive1();
    },
    SetActiveTab: (tabName: string) => {
      formRef?.current?.setActiveTabByName(tabName);
    },
    handleFormReady: async (form: any, RId: any) => {
      if (!formRef.current) return;

      console.log("OnLoad Triggered ", form, "RID: ", RId);
      console.log("OnLoad Triggered ", "TId: ", TId);
      console.log("OnLoad Triggered ", "CId: ", CId);
      console.log("OnLoad Triggered", "IsRedirectFromTaskCount: ", location?.state?.IsRedirectFromTaskCount);

      // //Redirection from task dashboard to task details tab handling
      // if ((location?.state?.IsRedirectFromTaskCount && location?.state?.IsRedirectFromTaskCount == true) ||
      //   (TId && TId > 0) || (CId && CId > 0)
      // ) {
      //   formRef?.current?.setActiveTabByName("Investigative Action Details");
      // }

      var IsComplaintIsDisabled = false;

      //#region Fetch Request Status and Hide/Show Enable/Disable fields accordingly
      const res = await API.post(FetchRequestOrUserContext, {
        RId: RId,
        UserId: commonContextParams?.userId
      });
      console.log("FetchRequestOrUserContext response", res);
      var DepartmentId = 0;
      var UnitId = 0;
      if (res?.data?.data) {
        RequestStatusId = res?.data?.data?.requestStatusId;

        // if (RequestStatusId == null || RequestStatusId == undefined) {
        //   RequestStatusId = 0;
        // }
      }
      let InitiatorDepartmentFlag = false;
      let InitiatorUnitFlag = false;
      if (RId == 0) {
        presetValues({
          Initiator: res?.data?.data?.userName ?? "",
          IssueReportedBy: `${res?.data?.data?.issueReportedBy ?? ""}`,
          InitiatorDepartment: `${res?.data?.data?.initiatorDepartment ?? ""}`,
          InitiatorUnit: `${res?.data?.data?.initiatorUnit ?? ""}`,
          ComplaintDate: dayjs().startOf("day"),
        });



        if (!res?.data?.data?.initiatorDepartment) {
          InitiatorDepartmentFlag = false;
        } else {
          InitiatorDepartmentFlag = true;
        }

        if (!res?.data?.data?.initiatorUnit) {
          InitiatorUnitFlag = false;
        } else {
          InitiatorUnitFlag = true;
        }

        if (Number(commonContextParams?.roleId) == Number(RoleEnum.Requestor)) {
          formRef.current?.setFieldVisibility([
            {
              fieldName: "InitiatorUnit",
              updates: { isFieldDisable: InitiatorUnitFlag },
            },
            {
              fieldName: "InitiatorDepartment",
              updates: { isFieldDisable: InitiatorDepartmentFlag },
            },
          ]);
        }
      }

      if (RequestStatusId == RequestStatusEnum.ComplaintInDraft ||
        RequestStatusId == 0
      ) {
        enableTabs(["Complaint Details"]);
        disableTabs([
          "Acknowledgement Details",
          "Investigative Action Details",
          "Corrective Action Details",
          "Closure Details (Sales Rep.)",
          "Closure Details (Central QA Team)",
        ]);
        if (Number(commonContextParams?.roleId) !== Number(RoleEnum.Requestor)) {
          formRef.current?.setFieldVisibility(
            ...handleFieldVisibility("Complaint Details", true),
          );
          IsComplaintIsDisabled = true;
        } else {
          if (RId > 0) {
            formRef.current?.setFieldVisibility([
              {
                fieldName: "InitiatorUnit",
                updates: { isFieldDisable: true },
              },
              {
                fieldName: "InitiatorDepartment",
                updates: { isFieldDisable: true },
              },
            ]);
          }
        }
      } else if (
        RequestStatusId == RequestStatusEnum.PendingCentralQaAcknowledgement
      ) {
        console.log("Request pending for acknowledgement 2");

        IsComplaintIsDisabled = true;
        formRef.current?.setFieldVisibility([
          ...handleFieldVisibility("Complaint Details", true),
        ]);

        enableTabs(["Complaint Details", "Acknowledgement Details"]);
        disableTabs(["Investigative Action Details", "Corrective Action Details",
          "Closure Details (Sales Rep.)", "Closure Details (Central QA Team)"]);
        if (Number(commonContextParams?.roleId) !== Number(RoleEnum.CentralQaTeam)) {
          formRef.current?.setFieldVisibility([
            // ...handleFieldVisibility("Complaint Details", true),
            ...handleFieldVisibility("Acknowledgement Details", true),
          ]);
        }
      } else if (
        RequestStatusId == RequestStatusEnum.ActionAssignmentPendingWithInvestigator ||
        RequestStatusId == RequestStatusEnum.TasksWipWithTaskOwner
      ) {
        console.log("Request pending for action - showing Investigative action details tab");

        IsComplaintIsDisabled = true;

        formRef.current?.setFieldVisibility([
          ...handleFieldVisibility("Complaint Details", true),
          ...handleFieldVisibility("Acknowledgement Details", true),
        ]);

        enableTabs(["Complaint Details", "Acknowledgement Details", "Investigative Action Details"]);
        disableTabs(["Corrective Action Details", "Closure Details (Sales Rep.)", "Closure Details (Central QA Team)"]);
      } else if (
        RequestStatusId == RequestStatusEnum.CorrectiveActionAssignmentPendingWithQa ||
        RequestStatusId == RequestStatusEnum.CorrectiveActionsWipWithOwner ||
        RequestStatusId == RequestStatusEnum.AllCorrectiveActionsClosed
      ) {
        console.log("Request pending for action - showing Investigative action details tab");

        IsComplaintIsDisabled = true;

        formRef.current?.setFieldVisibility([
          ...handleFieldVisibility("Complaint Details", true),
          ...handleFieldVisibility("Acknowledgement Details", true),
        ]);

        enableTabs(["Complaint Details", "Acknowledgement Details", "Investigative Action Details", "Corrective Action Details"]);
        disableTabs(["Closure Details (Sales Rep.)", "Closure Details (Central QA Team)"]);
      } else if (
        RequestStatusId == RequestStatusEnum.CustomerRatingPending
      ) {
        console.log("Request pending for Customer Rating Pending");

        IsComplaintIsDisabled = true;
        formRef.current?.setFieldVisibility([
          ...handleFieldVisibility("Complaint Details", true),
          ...handleFieldVisibility("Acknowledgement Details", true),
        ]);

        enableTabs(["Complaint Details", "Acknowledgement Details", "Investigative Action Details", "Corrective Action Details", "Closure Details (Sales Rep.)"]);
        disableTabs(["Closure Details (Central QA Team)"]);
        if (Number(commonContextParams?.roleId) !== Number(RoleEnum.SalesRepresentative)) {
          formRef.current?.setFieldVisibility([
            ...handleFieldVisibility("Complaint Details", true),
            ...handleFieldVisibility("Acknowledgement Details", true),
            ...handleFieldVisibility("Closure Details Sales Rep", true),
          ]);
        }
      } else if (
        RequestStatusId == RequestStatusEnum.CustomerRatingsUnderReview
      ) {
        console.log("Request pending for Customer Rating Pending");

        IsComplaintIsDisabled = true;
        formRef.current?.setFieldVisibility([
          ...handleFieldVisibility("Complaint Details", true),
          ...handleFieldVisibility("Acknowledgement Details", true),
          ...handleFieldVisibility("Closure Details Sales Rep", true),
        ]);

        enableTabs(["Complaint Details", "Acknowledgement Details", "Investigative Action Details", "Corrective Action Details", "Closure Details (Sales Rep.)", "Closure Details (Central QA Team)"]);

        if (Number(commonContextParams?.roleId) !== Number(RoleEnum.CentralQaTeam)) {
          formRef.current?.setFieldVisibility([
            ...handleFieldVisibility("Complaint Details", true),
            ...handleFieldVisibility("Acknowledgement Details", true),
            ...handleFieldVisibility("Closure Details Sales Rep", true),
            ...handleFieldVisibility("Closure Details QA Team", true),
          ]);

        }
      }
      else {
        enableTabs(["Complaint Details", "Acknowledgement Details", "Investigative Action Details", "Corrective Action Details", "Closure Details (Sales Rep.)", "Closure Details (Central QA Team)"]);
        formRef.current?.setFieldVisibility([
          ...handleFieldVisibility("Complaint Details", true),
          ...handleFieldVisibility("Acknowledgement Details", true),
          ...handleFieldVisibility("Closure Details Sales Rep", true),
          ...handleFieldVisibility("Closure Details QA Team", true),
        ]);
      }



      //#endregion

      ////Redirect to Action Details Tab Directly. Also Handle Re-trigger on Tab Change
      // if (
      //   !hasRedirected.current &&
      //   (
      //     location?.state?.IsRedirectFromTaskCount ||
      //     location?.state?.IsTaskDashboard ||
      //     location?.state?.IsCorrActionDashboard ||
      //     shouldRedirect == "true"
      //   )
      // ) {
      //   formRef?.current?.setActiveTabByName("Investigative Action Details");

      //   hasRedirected.current = true; // ✅ prevent re-run
      //   sessionStorage.removeItem("redirectToActionDetails");
      // }

      if (
        !hasRedirected.current &&
        (
          location?.state?.IsRedirectFromTaskCount ||
          location?.state?.IsTaskDashboard ||
          location?.state?.IsCorrActionDashboard ||
          shouldCorrActionRedirect == "true"
        )
      ) {

        if (location?.state?.IsCorrActionDashboard ||
          shouldCorrActionRedirect == "true") {
          formRef?.current?.setActiveTabByName("Corrective Action Details");

          hasRedirected.current = true; // ✅ prevent re-run
          sessionStorage.removeItem("redirectToCorrActionDetails");
        }
        else {

          if (location?.state?.IsRedirectFromTaskCount &&
            (RequestStatusId == RequestStatusEnum.ComplaintInDraft ||
              RequestStatusId == RequestStatusEnum.PendingCentralQaAcknowledgement
            )) {

          }
          else {

            formRef?.current?.setActiveTabByName("Investigative Action Details");

            hasRedirected.current = true; // ✅ prevent re-run
            sessionStorage.removeItem("redirectToActionDetails");
          }
        }
      }

    },
    ProcessComplaintDetailsTab: async (
      action: any,
      formValue: any,
      button: any,
      interfaceId: any,
    ) => {
      try {
        const formData = new FormData();

        // ==================================================
        // 🔵 1️⃣ Append All Non-File Fields Dynamically
        // ==================================================

        Object.entries(formValue).forEach(([key, value]: any) => {
          if (!Array.isArray(value)) {
            if (value && value.$d instanceof Date) {
              formData.append(key, value.toISOString());
            } else if (value !== undefined && value !== null) {
              formData.append(key, value);
            }
          }
        });


        if (formValue.rId != null)
          formData.append("RId", formValue.rId.toString());

        if (formValue.rId != null)
          formData.append("Id", formValue.rId.toString());

        if (formValue.userId != null)
          formData.append("CreatedBy", formValue.userId.toString());

        if (formValue.roleId != null)
          formData.append("RoleId", formValue.roleId.toString());

        if (action.actionKey == "DynamicFormActionSave")
          formData.append("IsDraftRequest", "true");

        // ==================================================
        // 🔵 2️⃣ Detect All File Fields Automatically
        // ==================================================

        const fileFieldKeys = Object.keys(formValue).filter(
          (key) =>
            Array.isArray(formValue[key]) &&
            formValue[key].some(
              (item: any) =>
                item?.originFileObj || item?.url || item?.path
            )
        );

        const attachmentMap: any = {};

        // ==================================================
        // 🔵 3️⃣ Process Each File Field
        // ==================================================

        fileFieldKeys.forEach((fieldKey) => {
          const files = formValue[fieldKey] ?? [];

          const oldAttachments: any[] = [];

          files.forEach((file: any) => {
            if (file.originFileObj) {
              // 🟢 New file
              // formData.append(fieldKey, file.originFileObj);
              formData.append("NewAttachments", file.originFileObj);
            } else {
              // 🔵 Old file
              oldAttachments.push({
                id: file.id ?? "",
                name: file.name ?? "",
                path: file.path ?? file.url ?? ""
              });
            }
          });

          //attachmentMap[fieldKey] = oldAttachments;
          formData.append(
            "AttachmentJson",
            JSON.stringify(oldAttachments)
          );
        });

        // ==================================================
        // 🔵 4️⃣ Send Old Metadata For All Fields
        // ==================================================

        // formData.append(
        //   "AttachmentJson",
        //   JSON.stringify(attachmentMap)
        // );

        // ==================================================
        // 🔵 5️⃣ Call API
        // ==================================================

        const response = await API.post(
          InitiateComplaintAsync,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        console.log("response from API:", response);

        if (
          response?.data?.message === "OK" &&
          response?.data?.status === ApiStatus.Success
        ) {

          // if (commonContextParams.roleId == RoleEnum.Requestor) {
          message.success("Complaint Saved successfully.");
          //navigate(-1);
          navigate("/ComplaintsDashboard");
          return response;
          // }
          // else {
          //   formRef?.current?.setActiveTabByName("Acknowledgement Details");
          // }

        } else {
          message.error(
            response?.data?.errorCode === "DBVALIDATION"
              ? response.data.message
              : response?.data?.message || "Failed.",
          );

          if (response?.data?.nextActionUserNotFound) {
            setTimeout(() => {
              // navigate(-1); // go back
              navigate("/ComplaintsDashboard");
            }, 2000);

            return null; // stop further execution if needed
          }

          return null;
        }

      } catch (error: any) {
        console.error(error);
        message.error("Something went wrong. Please try again.");
        return null;
      }
    },
    ProcessAcknowledgementDetailsTab: async (
      action: any,
      formValue: any,
      button: any,
      interfaceId: any,
    ) => {
      try {
        const formData = new FormData();

        // ==================================================
        // 🔵 1️⃣ Append All Non-File Fields Dynamically
        // ==================================================

        Object.entries(formValue).forEach(([key, value]: any) => {
          if (!Array.isArray(value)) {
            if (value && value.$d instanceof Date) {
              formData.append(key, value.toISOString());
            } else if (value !== undefined && value !== null) {
              formData.append(key, value);
            }
          }
        });


        if (formValue.rId != null)
          formData.append("RId", formValue.rId.toString());

        if (formValue.rId != null)
          formData.append("Id", formValue.rId.toString());

        if (formValue.userId != null)
          formData.append("CreatedBy", formValue.userId.toString());

        if (formValue.roleId != null)
          formData.append("RoleId", formValue.roleId.toString());

        // ==================================================
        // 🔵 2️⃣ Detect All File Fields Automatically
        // ==================================================

        const fileFieldKeys = Object.keys(formValue).filter(
          (key) =>
            Array.isArray(formValue[key]) &&
            formValue[key].some(
              (item: any) =>
                item?.originFileObj || item?.url || item?.path
            )
        );

        const attachmentMap: any = {};

        // ==================================================
        // 🔵 3️⃣ Process Each File Field
        // ==================================================

        fileFieldKeys.forEach((fieldKey) => {
          const files = formValue[fieldKey] ?? [];

          const oldAttachments: any[] = [];

          files.forEach((file: any) => {
            if (file.originFileObj) {
              // 🟢 New file
              // formData.append(fieldKey, file.originFileObj);
              formData.append("NewAttachments", file.originFileObj);
            } else {
              // 🔵 Old file
              oldAttachments.push({
                id: file.id ?? "",
                name: file.name ?? "",
                path: file.path ?? file.url ?? ""
              });
            }
          });

          //attachmentMap[fieldKey] = oldAttachments;
          formData.append(
            "AttachmentJson",
            JSON.stringify(oldAttachments)
          );
        });

        // ==================================================
        // 🔵 4️⃣ Send Old Metadata For All Fields
        // ==================================================

        // formData.append(
        //   "AttachmentJson",
        //   JSON.stringify(attachmentMap)
        // );

        // ==================================================
        // 🔵 5️⃣ Call API
        // ==================================================

        const response = await API.post(
          InitiateAcknowledgementAsync,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (
          response?.data?.message === "OK" &&
          response?.data?.status === ApiStatus.Success
        ) {
          message.success("Saved successfully.");
          //navigate(-1);
          navigate("/ComplaintsDashboard");
          return response;
        } else {
          message.error(
            response?.data?.errorCode === "DBVALIDATION"
              ? response.data.message
              : response?.data?.message || "Failed.",
          );
          return null;
        }

      } catch (error: any) {
        console.error(error);
        message.error("Something went wrong. Please try again.");
        return null;
      }
    },
    ProcessSalesClosureDetailsTab: async (
      action: any,
      formValue: any,
      button: any,
      interfaceId: any,
    ) => {
      try {
        const formData = new FormData();

        // ==================================================
        // 🔵 1️⃣ Append All Non-File Fields Dynamically
        // ==================================================

        Object.entries(formValue).forEach(([key, value]: any) => {
          if (!Array.isArray(value)) {
            if (value && value.$d instanceof Date) {
              formData.append(key, value.toISOString());
            } else if (value !== undefined && value !== null) {
              formData.append(key, value);
            }
          }
        });


        if (formValue.rId != null)
          formData.append("RId", formValue.rId.toString());

        if (formValue.rId != null)
          formData.append("Id", formValue.rId.toString());

        if (formValue.userId != null)
          formData.append("CreatedBy", formValue.userId.toString());

        if (formValue.roleId != null)
          formData.append("RoleId", formValue.roleId.toString());

        // ==================================================
        // 🔵 2️⃣ Detect All File Fields Automatically
        // ==================================================

        const fileFieldKeys = Object.keys(formValue).filter(
          (key) =>
            Array.isArray(formValue[key]) &&
            formValue[key].some(
              (item: any) =>
                item?.originFileObj || item?.url || item?.path
            )
        );

        const attachmentMap: any = {};

        // ==================================================
        // 🔵 3️⃣ Process Each File Field
        // ==================================================

        fileFieldKeys.forEach((fieldKey) => {
          const files = formValue[fieldKey] ?? [];

          const oldAttachments: any[] = [];

          files.forEach((file: any) => {
            if (file.originFileObj) {
              // 🟢 New file
              // formData.append(fieldKey, file.originFileObj);
              formData.append("NewAttachments", file.originFileObj);
            } else {
              // 🔵 Old file
              oldAttachments.push({
                id: file.id ?? "",
                name: file.name ?? "",
                path: file.path ?? file.url ?? ""
              });
            }
          });

          //attachmentMap[fieldKey] = oldAttachments;
          formData.append(
            "AttachmentJson",
            JSON.stringify(oldAttachments)
          );
        });

        // ==================================================
        // 🔵 4️⃣ Send Old Metadata For All Fields
        // ==================================================

        // formData.append(
        //   "AttachmentJson",
        //   JSON.stringify(attachmentMap)
        // );

        // ==================================================
        // 🔵 5️⃣ Call API
        // ==================================================

        const response = await API.post(
          InitiateSalesClosureAsync,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (
          response?.data?.message === "OK" &&
          response?.data?.status === ApiStatus.Success
        ) {
          message.success("Saved successfully.");
          // navigate(-1);
          navigate("/ComplaintsDashboard");
          return response;
        } else {
          message.error(
            response?.data?.errorCode === "DBVALIDATION"
              ? response.data.message
              : response?.data?.message || "Failed.",
          );
          return null;
        }

      } catch (error: any) {
        console.error(error);
        message.error("Something went wrong. Please try again.");
        return null;
      }
    },
    ProcessQAClosureDetailsTab: async (
      action: any,
      formValue: any,
      button: any,
      interfaceId: any,
    ) => {
      try {
        const formData = new FormData();

        // ==================================================
        // 🔵 1️⃣ Append All Non-File Fields Dynamically
        // ==================================================

        Object.entries(formValue).forEach(([key, value]: any) => {
          if (!Array.isArray(value)) {
            if (value && value.$d instanceof Date) {
              formData.append(key, value.toISOString());
            } else if (value !== undefined && value !== null) {
              formData.append(key, value);
            }
          }
        });


        if (formValue.rId != null)
          formData.append("RId", formValue.rId.toString());

        if (formValue.rId != null)
          formData.append("Id", formValue.rId.toString());

        if (formValue.userId != null)
          formData.append("CreatedBy", formValue.userId.toString());

        if (formValue.roleId != null)
          formData.append("RoleId", formValue.roleId.toString());

        // ==================================================
        // 🔵 2️⃣ Detect All File Fields Automatically
        // ==================================================

        const fileFieldKeys = Object.keys(formValue).filter(
          (key) =>
            Array.isArray(formValue[key]) &&
            formValue[key].some(
              (item: any) =>
                item?.originFileObj || item?.url || item?.path
            )
        );

        const attachmentMap: any = {};

        // ==================================================
        // 🔵 3️⃣ Process Each File Field
        // ==================================================

        fileFieldKeys.forEach((fieldKey) => {
          const files = formValue[fieldKey] ?? [];

          const oldAttachments: any[] = [];

          files.forEach((file: any) => {
            if (file.originFileObj) {
              // 🟢 New file
              // formData.append(fieldKey, file.originFileObj);
              formData.append("NewAttachments", file.originFileObj);
            } else {
              // 🔵 Old file
              oldAttachments.push({
                id: file.id ?? "",
                name: file.name ?? "",
                path: file.path ?? file.url ?? ""
              });
            }
          });

          //attachmentMap[fieldKey] = oldAttachments;
          formData.append(
            "AttachmentJson",
            JSON.stringify(oldAttachments)
          );
        });

        // ==================================================
        // 🔵 4️⃣ Send Old Metadata For All Fields
        // ==================================================

        // formData.append(
        //   "AttachmentJson",
        //   JSON.stringify(attachmentMap)
        // );

        // ==================================================
        // 🔵 5️⃣ Call API
        // ==================================================

        const response = await API.post(
          InitiateQAClosureAsync,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (
          response?.data?.message === "OK" &&
          response?.data?.status === ApiStatus.Success
        ) {
          message.success("Saved successfully.");
          //navigate(-1);
          navigate("/ComplaintsDashboard");
          return response;
        } else {
          message.error(
            response?.data?.errorCode === "DBVALIDATION"
              ? response.data.message
              : response?.data?.message || "Failed.",
          );
          return null;
        }

      } catch (error: any) {
        console.error(error);
        message.error("Something went wrong. Please try again.");
        return null;
      }
    },
    // ProcessComplaintDetailsTab: async (
    //   action: any,
    //   formValue: any,
    //   button: any,
    //   interfaceId: any,
    // ) => {
    //   try {

    //     const attachments = await prepareAttachments(
    //       formValue,
    //       "SupportingDocuments"
    //     );

    //     const payload = {
    //       rId: formValue.RId ?? null,
    //       id: formValue.RId ?? null,
    //       createdBy: formValue.userId ?? null,
    //       roleId: formValue.roleId ?? null,

    //       ComplaintDate: formValue.ComplaintDate
    //         ? new Date(formValue.ComplaintDate).toISOString()
    //         : null,
    //       IssueReportedBy: formValue.IssueReportedBy ?? null,
    //       ComplaintTitle: formValue.ComplaintTitle ?? null,
    //       Description: formValue.Description ?? null,
    //       InitiatorDepartment: formValue.InitiatorDepartment ?? null,
    //       InitiatorUnit: formValue.InitiatorUnit ?? null,
    //       Priority: formValue.Priority ?? null,
    //       Series: formValue.Series ?? null,
    //       BusinessChannel: formValue.BusinessChannel ?? null,
    //       ContactChannel: formValue.ContactChannel ?? null,
    //       CustomerName: formValue.CustomerName ?? null,
    //       ContactPerson: formValue.ContactPerson ?? null,
    //       ContactNumber: formValue.ContactNumber ?? null,
    //       EmailAddress: formValue.EmailAddress ?? null,
    //       CustomerCode: formValue.CustomerCode ?? null,
    //       CustomerAddress: formValue.CustomerAddress ?? null,
    //       City: formValue.City ?? null,
    //       Country: formValue.Country ?? null,
    //       Product: formValue.Product ?? null,
    //       ProductDescription: formValue.ProductDescription ?? null,
    //       ProductCode: formValue.ProductCode ?? null,
    //       //Attachment: attachments.length > 0 ? attachments : null,
    //     };

    //     const updateResponse = await API.post(InitiateComplaintAsync, payload);

    //     if (updateResponse?.data?.status !== 0) {
    //       message.error(
    //         updateResponse?.data?.errorCode === "DBVALIDATION"
    //           ? updateResponse.data.message
    //           : updateResponse?.data?.message || "Failed.",
    //       );
    //       return null;
    //     }

    //     message.success("Updated successfully.");
    //     return updateResponse.data;
    //   } catch (error: any) {
    //     message.error("Something went wrong. Please try again.");
    //     return null;
    //   }
    // },
    handleFileSubmit: async (actionType: string, ...params: any[]) => {
      const formData = params[0];
      const responseData: any[] = [];

      const uploadFieldKeys = Object.keys(formData).filter(
        (key) => Array.isArray(formData[key]) && formData[key].length > 0
      );

      const hasAnyFile = uploadFieldKeys.some((fieldKey) =>
        formData[fieldKey].some((file: any) => file?.originFileObj)
      );
      if (!hasAnyFile) {
        return {
          data: {
            status: 0,
            message: "OK",
            data: [],
          },
        };
      }

      for (const fieldKey of uploadFieldKeys) {
        const uploadedFiles: any[] = [];

        for (const file of formData[fieldKey]) {
          const fd = new FormData();
          fd.append("File", file.originFileObj);
          fd.append("Overwrite", "true");
          fd.append("Container", "Documents");
          fd.append("FolderPath", "Kuldeep/hhh");

          const res = await API.post("/Documents/upload", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          uploadedFiles.push({
            name: file.name,
            path: res.data.DocumentUrl,
            id: res.data.DocumentId,
          });
        }

        // update form per field
        formRef.current!.setValue(fieldKey, uploadedFiles);

        responseData.push({
          key: fieldKey,
          value: uploadedFiles,
          Id: 0,
          IsActive: false,
        });
      }

      return {
        data: {
          status: 0,
          message: "OK",
          data: responseData,
        },
      };
    },

    // Update existing + new files
    handleFileUpdate: async (actionType: string, ...params: any[]) => {
      const formData = params[0];
      const responseData: any[] = [];

      // 🔹 detect all upload fields dynamically
      const uploadFields = Object.keys(formData).filter((key) =>
        Array.isArray(formData[key])
      );

      for (const fieldKey of uploadFields) {
        const fieldFiles = formData[fieldKey] ?? [];
        const normalizedFiles: any[] = [];

        for (const file of fieldFiles) {
          // 🟢 Already uploaded file (no API call)
          if ((file.url || file.path) && !file.originFileObj) {
            normalizedFiles.push({
              name: file.name ?? file.url?.split("/").pop(),
              path:
                file.path ??
                (file.url.startsWith("/") ? file.url.substring(1) : file.url),
              id: file.id ? String(file.id) : "",
            });
          }
          // 🟡 New file → upload
          else if (file.originFileObj) {
            const fd = new FormData();
            fd.append("File", file.originFileObj);
            fd.append("Overwrite", "true");
            fd.append("Container", "Documents");

            try {
              const res = await API.post("/Documents/upload", fd, {
                headers: { "Content-Type": "multipart/form-data" },
              });

              normalizedFiles.push({
                name: res.data.Data.Name ?? file.name,
                path: res.data.Data.DocumentUrl,
                id: String(res.data.Data.DocumentId),
              });
            } catch (err) {
              console.error(`Upload failed for ${fieldKey}, err:`, err);
            }
          }
        }

        // 🔹 update form per field
        formRef.current!.setValue(fieldKey, normalizedFiles);

        responseData.push({
          key: fieldKey,
          value: normalizedFiles,
        });
      }

      return {
        data: {
          status: 0,
          message: "OK",
          data: responseData,
        },
      };
    },
  };

  const interfaceFieldActionHandler = {

    hideShowTabsOnFieldChange: async (form: any) => {
      let formData: Record<string, any>;
      if ("getFieldsValue" in form) {
        formData = form.getFieldsValue();
      } else {
        formData = form;
      }
      console.log(formData);
    },
  };




  return (
    <>
      <ActionHandlerProvider
        interfaceActionHandler={interfaceActionHandler}
        interfaceFieldActionHandler={interfaceFieldActionHandler}
      >
        <InterfaceComponent
          InterfaceName={"Request Details Interface"}
          DashboardName={""}
          actionType={"DynamicFormActionCreate"}
          RId={null}
          Mode={"Create"}
          handleCancel={handleCancel1}
          ref={formRef}
        // onFormReady={handleFormReady}
        />
      </ActionHandlerProvider>
    </>
  );
};

export default RequestDetailInterface;
